import { Box, Typography } from '@mui/material';

const drawerFormGridSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(12, minmax(0, 1fr))',
  },
  columnGap: 1.5,
  rowGap: 1.25,
  alignItems: 'start',
};

const DrawerFormSection = ({
  title,
  action,
  children,
  grid = true,
  contentSx = {},
  sx = {},
}) => (
  <Box
    sx={{
      mx: { xs: 1.25, md: 2 },
      px: { xs: 1.5, md: 2 },
      py: { xs: 1.5, md: 2 },
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      backgroundColor: 'background.paper',
      minWidth: 0,
      ...sx,
    }}
  >
    {(title || action) && (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1.5,
          flexWrap: 'wrap',
          mb: 1.5,
          minWidth: 0,
        }}
      >
        {title && (
          <Typography
            variant="subtitle1"
            sx={{
              color: 'primary.main',
              fontWeight: 700,
              fontSize: '0.95rem',
              lineHeight: 1.25,
              minWidth: 0,
            }}
          >
            {title}
          </Typography>
        )}
        {action && (
          <Box sx={{ flexShrink: 0, minWidth: { xs: '100%', sm: 0 }, display: 'flex', justifyContent: 'flex-end' }}>
            {action}
          </Box>
        )}
      </Box>
    )}
    <Box sx={grid ? { ...drawerFormGridSx, ...contentSx } : contentSx}>{children}</Box>
  </Box>
);

export default DrawerFormSection;
